module.exports = __webpack_public_path__ + "static/media/folha1.7330891a.png";